import { render, staticRenderFns } from "./AssetDetailsInfo.vue?vue&type=template&id=1a3e4362&scoped=true&"
import script from "./AssetDetailsInfo.vue?vue&type=script&lang=js&"
export * from "./AssetDetailsInfo.vue?vue&type=script&lang=js&"
import style0 from "./AssetDetailsInfo.vue?vue&type=style&index=0&id=1a3e4362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3e4362",
  null
  
)

export default component.exports